import React from 'react';
import { useDnD } from './DnDContext';

export default () => {
    const [_, setType] = useDnD();

    const onDragStart = (event, nodeType) => {
        setType(nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className="d-flex rounded-bottom overflow-hidden align-items-start bg-white rounded-bottom-3 formbuilder-body">
            <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 global-tab">

                <div className="search-div mb-3">
                    <div className="input-group">
                        <span className="input-group-text">
                            <i className="pluto-search"></i>
                        </span>
                        <input
                            type="search"
                            className="form-control"
                            placeholder="Search element"
                        />
                    </div>
                </div>

                <ul className='workflow-nav list-unstyled'>
                    <li className='text-sm font-medium'>
                        <a href="#" className='d-flex align-items-center gap-1 text-decoration-none'>
                            <i className="bx bx-clipboard nav_icon"></i> Copy from Templates <i className='bx bx-chevron-right bx-sm ms-auto'></i>
                        </a>
                    </li>
                </ul>
                <div>
                    <span className='d-block mb-2 text-sm font-medium'>Elemments</span>

                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode input' onDragStart={(event) => onDragStart(event, 'start')} draggable><img src='/assets/images/icons/events/start-event.svg'/> Start event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode' onDragStart={(event) => onDragStart(event, 'action')} draggable><img src='/assets/images/icons/events/action-event.svg'/> Action event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode' onDragStart={(event) => onDragStart(event, 'decision')} draggable><img src='/assets/images/icons/events/decision-event.svg'/> Decision event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode' onDragStart={(event) => onDragStart(event, 'loop')} draggable><img src='/assets/images/icons/events/loop-event.svg'/> Loop event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode' onDragStart={(event) => onDragStart(event, 'task')} draggable><img src='/assets/images/icons/events/task-event.svg'/> Task event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode' onDragStart={(event) => onDragStart(event, 'wait')} draggable><img src='/assets/images/icons/events/wait-event.svg'/> Wait event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode' onDragStart={(event) => onDragStart(event, 'notification')} draggable><img src='/assets/images/icons/events/notification-event.svg'/> Notification event</p>
                    <p className='p-5 d-flex justify-content-start align-items-center gap-1 text-decoration-none border border-grey-300 rounded-md dndnode output' onDragStart={(event) => onDragStart(event, 'end')} draggable><img src='/assets/images/icons/events/end-event.svg'/> End event</p>

                </div>

            </div>
        </div>
    );
};
